export default "__VITE_ASSET__DpAgiS6L__"